
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('rect',{attrs:{"width":"24","height":"16","rx":"2","fill":"#E6E6E9"}}),_c('text',{attrs:{"x":"12","y":"10.5","text-anchor":"middle","font-size":"8","font-family":"Arial, sans-serif","font-weight":"bold","fill":"#B3B4BD"}},[_v('ACH')])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v16H0z"}})])])])
          )
        }
      }
    